/**
 * Liberação do Cakto Analytics (CKTPL-1723).
 *
 * Lê o campo próprio `user.caktoAnalyticsEnabled`, e não `experimental_features`: aquela lista
 * viaja no payload cacheado do `/user/` e não acompanha a liberação pelo M2M nem a switch
 * `cakto_analytics_todos`. Comparação estrita com `true` porque, antes de o backend expor o
 * campo (ou de o usuário carregar), ele vem `undefined` e esconder é o lado seguro de errar.
 */
export const CAKTO_ANALYTICS_FLAG = 'caktoAnalyticsEnabled';

export const isCaktoAnalyticsEnabled = (user) => user?.[CAKTO_ANALYTICS_FLAG] === true;

/**
 * A aba do Pro aparece para quem já tem o Pro (liberado à mão, placa ou assinatura) ou pode
 * comprá-lo (`purchasable`, a venda aberta). Com a venda fechada e sem liberação, não há o que
 * mostrar: a aba some em vez de exibir um plano que ninguém consegue assinar.
 */
export const CAKTO_ANALYTICS_PRO_FLAG = 'caktoAnalyticsPro';

export const isCaktoAnalyticsProVisible = (user) => {
  const pro = user?.[CAKTO_ANALYTICS_PRO_FLAG];
  return pro?.active === true || pro?.purchasable === true;
};

/** Tem o Pro agora (liberado à mão, placa ou assinatura): abre 12 meses e todos os produtos. */
export const isCaktoAnalyticsProActive = (user) =>
  user?.[CAKTO_ANALYTICS_PRO_FLAG]?.active === true;
